import { formatDistanceToNow } from 'date-fns';

// Lazy load markdown dependencies (may not be installed yet)
let ReactMarkdown, remarkGfm, SyntaxHighlighter, vscDarkPlus;

try {
  ReactMarkdown = require('react-markdown').default;
  remarkGfm = require('remark-gfm').default;
  const Prism = require('react-syntax-highlighter');
  SyntaxHighlighter = Prism.Prism || Prism.default?.Prism;
  vscDarkPlus = require('react-syntax-highlighter/dist/esm/styles/prism').vscDarkPlus;
} catch (e) {
  // Packages not installed yet - will use plain text fallback
  console.log('Markdown packages not installed, using plain text');
}

export default function ChatMessage({ message, isUser }) {
  const timestamp = message.timestamp?.toDate 
    ? message.timestamp.toDate() 
    : new Date(message.timestamp || Date.now());

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-4`}>
      <div className={`max-w-[85%] sm:max-w-[75%] flex flex-col ${isUser ? 'items-end' : 'items-start'}`}>
        <div
          className={`rounded-2xl p-4 ${
            isUser
              ? 'bg-primary text-white'
              : 'bg-surface text-text-primary'
          }`}
        >
          {isUser ? (
            <div className="text-sm sm:text-base leading-relaxed whitespace-pre-wrap">
              {message.content}
            </div>
          ) : ReactMarkdown ? (
            <div className="prose prose-sm sm:prose-base max-w-none">
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                  code({ node, inline, className, children, ...props }) {
                    const match = /language-(\w+)/.exec(className || '');
                    return !inline && match && SyntaxHighlighter ? (
                      <SyntaxHighlighter
                        style={vscDarkPlus}
                        language={match[1]}
                        PreTag="div"
                        {...props}
                      >
                        {String(children).replace(/\n$/, '')}
                      </SyntaxHighlighter>
                    ) : (
                      <code className={className} {...props}>
                        {children}
                      </code>
                    );
                  },
                }}
              >
                {message.content}
              </ReactMarkdown>
            </div>
          ) : (
            <div className="text-sm sm:text-base leading-relaxed whitespace-pre-wrap">
              {message.content}
            </div>
          )}
        </div>
        <div className={`text-xs text-text-secondary mt-1 px-1 ${isUser ? 'text-right' : 'text-left'}`}>
          {formatDistanceToNow(timestamp, { addSuffix: true })}
        </div>
      </div>
    </div>
  );
}

